import { Team, Player } from '../types';
import skavenData from '../data/Skaven.json';
import woodElfData from '../data/WoodElf.json';

// Helper to create a player from JSON data
const createPlayer = (posName: string, data: any, number: number): Player => {
  const stats = data.Positionals.find((p: any) => p.Position === posName);
  return {
    number,
    name: `${posName} ${number}`,
    position: posName,
    stats: stats ? {
      MA: stats.MA, ST: stats.ST, AG: stats.AG, PA: stats.PA, AR: stats.AR,
      Skills: stats.Skills.join(', '),
      Primary: stats.Primary, Secondary: stats.Secondary, Cost: stats.Cost
    } : undefined
  };
};

export const PRESET_TEAMS: Record<string, () => Team> = {
  'Skaven': () => {
    const players: Player[] = [];
    let num = 1;
    // 4 Gutter Runners
    for(let i=0; i<4; i++) players.push(createPlayer('Gutter Runner', skavenData, num++));
    // 2 Blitzers
    for(let i=0; i<2; i++) players.push(createPlayer('Blitzer', skavenData, num++));
    // 1 Thrower
    players.push(createPlayer('Thrower', skavenData, num++));
    // Rest Linemen
    while(num <= 16) players.push(createPlayer('Skaven Clanrat Lineman', skavenData, num++));

    return {
      id: 'preset-skaven',
      teamName: 'Skaven Speedsters',
      region: 'Skaven',
      coachName: 'Trainer',
      players,
      formations: [],
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
  },
  'Wood Elf': () => {
    const players: Player[] = [];
    let num = 1;
    // 2 Wardancers
    for(let i=0; i<2; i++) players.push(createPlayer('Wardancer', woodElfData, num++));
    // 4 Catchers
    for(let i=0; i<4; i++) players.push(createPlayer('Catcher', woodElfData, num++));
    // 1 Thrower
    players.push(createPlayer('Thrower', woodElfData, num++));
    // Rest Linemen
    while(num <= 16) players.push(createPlayer('Wood Elf Lineman', woodElfData, num++));

    return {
      id: 'preset-woodelf',
      teamName: 'Forest Sprinters',
      region: 'Wood Elf',
      coachName: 'Trainer',
      players,
      formations: [],
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
  }
};